'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');
const components_display_FloatingBox_FloatingBox = require('../../display/FloatingBox/FloatingBox.cjs.js');

const MENU_ITEM_HEIGHT = 40;
const Styles = styleEncapsulation.labelStyles("FloatingMenu", {
  list: ({ visibleItems }) => [
    Object.assign(Object.assign({}, styleMixins_reset.baseReset), { maxHeight: ((visibleItems || 0) + 0.5) * MENU_ITEM_HEIGHT + 10, overflow: "auto", padding: 10 })
  ],
  menuItem: ({ isDisabled, isHighlighted }) => [
    Object.assign(Object.assign(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { display: "flex", alignItems: "center", height: `var(--zds-space-32)`, padding: "0 10px" }), theme_Typography.Typography.Body2), { color: `var(--zds-text-default)`, borderRadius: "var(--zds-radius-small)", cursor: "pointer" }),
    isDisabled && styleEncapsulation.withModifier("disabled", Object.assign(Object.assign({}, theme_Typography.Typography.Body2), { color: `var(--zds-text-weakest)` })),
    isHighlighted && styleEncapsulation.withModifier("enabled-highlighted", Object.assign(Object.assign({}, theme_Typography.Typography.Body2), { color: `var(--zds-ui-primary-strongest)`, backgroundColor: `var(--zds-ui-primary-weakest)` }))
  ],
  menuItemIcon: react.css(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10 })),
  menuItemText: react.css(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }))
});
const FloatingMenu = (_props) => {
  const props = Object.assign({ align: "stretch", visibleItems: 4 }, _props);
  const { align, "aria-label": ariaLabel, getItemProps, getKeyForItem, getLabelForItem, getMenuProps, highlightedIndex, items, maxWidth, minWidth } = props;
  return react.jsx(
    components_display_FloatingBox_FloatingBox.FloatingBox,
    { align, maxWidth, minWidth },
    react.jsx("ul", Object.assign({ css: Styles.list(props) }, getMenuProps({ "aria-label": ariaLabel }), { "data-zds": true }), items.map((item, index) => react.jsx(
      "li",
      Object.assign({}, getItemProps({ item, disabled: item.disabled }), { css: Styles.menuItem({
        isDisabled: item.disabled,
        isHighlighted: highlightedIndex === index
      }), key: getKeyForItem ? getKeyForItem(item) : index, "data-zds": true }),
      props.renderIcon && react.jsx("span", { css: Styles.menuItemIcon, "data-zds": true }, props.renderIcon(item, props.getLabelForItem)),
      react.jsx("span", { css: Styles.menuItemText, "data-zds": true }, getLabelForItem(item))
    )))
  );
};

exports.FloatingMenu = FloatingMenu;
//# sourceMappingURL=FloatingMenu.cjs.js.map
